var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39062 14.8047C7.04167 14.8047 7.53385 14.5547 7.86719 14.0547L15.0781 3.1875C15.1979 3.01042 15.2865 2.83594 15.3438 2.66406C15.401 2.48698 15.4297 2.31771 15.4297 2.15625C15.4297 1.70833 15.2734 1.33854 14.9609 1.04688C14.6536 0.75 14.2734 0.601562 13.8203 0.601562C13.5078 0.601562 13.2422 0.664062 13.0234 0.789062C12.8099 0.908854 12.6068 1.11719 12.4141 1.41406L6.35938 10.9219L3.32812 7.28906C3 6.90885 2.58854 6.71875 2.09375 6.71875C1.63021 6.71875 1.2474 6.86719 0.945312 7.16406C0.643229 7.46094 0.492188 7.83333 0.492188 8.28125C0.492188 8.48438 0.523438 8.67708 0.585938 8.85938C0.653646 9.03646 0.776042 9.22135 0.953125 9.41406L4.97656 14.1562C5.34635 14.5885 5.81771 14.8047 6.39062 14.8047Z",
    fill: "#2D3133"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2c6b51742a7ab6747145e95f966e253d.svg";
export { ForwardRef as ReactComponent };